var _rect, _rect2, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 185,
    viewBox: "0 0 1366 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 185,
    fill: "#40B8E9",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5367_357306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1366,
    height: 185
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 185,
    fill: "#F5F8FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5367_357306)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.7 139.979C1315.63 99.3529 1331.32 60.289 1359.11 29.4391C1371.57 17.0081 1379.92 1.37034 1383.13 -15.535C1386.34 -32.4404 1384.26 -49.8697 1377.16 -65.6618C1370.05 -81.4539 1358.23 -94.9141 1343.16 -104.373C1328.1 -113.833 1310.44 -118.875 1292.39 -118.875C1274.34 -118.875 1256.69 -113.833 1241.62 -104.373C1226.55 -94.9141 1214.73 -81.4539 1207.63 -65.6618C1200.53 -49.8697 1198.45 -32.4404 1201.65 -15.535C1204.86 1.37034 1213.21 17.0081 1225.67 29.4391V29.5673C1242.05 48.3581 1257.24 73.1477 1266.75 110.217C1272.14 130.853 1280.22 143.312 1293.69 149.926C1306.91 154.72 1314.7 152.208 1314.7 139.979Z",
    fill: "#E2F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.901 148.563C992.974 189.182 977.276 228.239 949.482 259.077C937.024 271.508 928.674 287.146 925.467 304.051C922.26 320.956 924.338 338.386 931.442 354.178C938.546 369.97 950.365 383.43 965.433 392.889C980.5 402.349 998.154 407.391 1016.2 407.391C1034.25 407.391 1051.91 402.349 1066.98 392.889C1082.04 383.43 1093.86 369.97 1100.97 354.178C1108.07 338.386 1110.15 320.956 1106.94 304.051C1103.73 287.146 1095.38 271.508 1082.93 259.077V258.949C1066.55 240.158 1051.36 215.369 1041.85 178.3C1036.46 157.792 1028.38 145.205 1014.91 138.591C1001.74 133.669 993.901 136.181 993.901 148.563Z",
    fill: "#E2F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.35 237.136C1263.11 217.127 1210.5 180.512 1172.2 131.952C1133.9 83.3919 1111.65 25.0839 1108.29 -35.5487C1107.49 -51.5291 1102.12 -66.9979 1092.74 -80.2784C1083.37 -93.559 1070.36 -104.145 1055.11 -110.888C1039.87 -117.632 1022.98 -120.276 1006.27 -118.535C989.555 -116.793 973.665 -110.732 960.316 -101.008C946.967 -91.2843 936.669 -78.2689 930.538 -63.3725C924.408 -48.476 922.678 -32.2668 925.537 -16.5016C928.396 -0.736406 935.734 13.9834 946.757 26.0625C957.78 38.1415 972.066 47.1191 988.067 52.0221C1047.9 72.456 1100.02 109.306 1137.86 157.917C1175.69 206.528 1197.55 264.719 1200.65 325.142C1200.64 325.21 1200.64 325.279 1200.65 325.347C1201.71 341.136 1207.25 356.357 1216.66 369.394C1226.08 382.432 1239.03 392.799 1254.14 399.396C1269.25 405.994 1285.96 408.574 1302.48 406.864C1319.01 405.155 1334.74 399.218 1348.01 389.685C1361.28 380.152 1371.59 367.378 1377.84 352.72C1384.09 338.061 1386.06 322.064 1383.53 306.427C1381 290.79 1374.07 276.096 1363.48 263.906C1352.88 251.715 1339.01 242.482 1323.35 237.187V237.136Z",
    fill: "#E2F4FC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title_bg.e600aa5c7cce9335297d6dbad3d207a8.svg";
export { ForwardRef as ReactComponent };